import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-[10px]" }
const _hoisted_2 = { class: "inline-block mb-[15px] ltr:mr-[11px] rtl:ml-[11px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_3 = { class: "inline-block mb-[15px] ltr:mr-[11px] rtl:ml-[11px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_4 = { class: "inline-block mb-[15px] ltr:mr-[11px] rtl:ml-[11px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_5 = { class: "inline-block mb-[15px] ltr:mr-[11px] rtl:ml-[11px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_6 = { class: "inline-block mb-[15px] ltr:mr-[11px] rtl:ml-[11px] ltr:last:mr-0 rtl:last:ml-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _createVNode(_component_RouterLink, {
        to: "/settings/account-settings",
        class: "block rounded-md font-medium py-[8.5px] px-[15px] text-primary-500 border border-primary-500 transition-all hover:bg-primary-500 hover:text-white"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.accountSettings')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", _hoisted_3, [
      _createVNode(_component_RouterLink, {
        to: "/settings/change-password",
        class: "block rounded-md font-medium py-[8.5px] px-[15px] text-primary-500 border border-primary-500 transition-all hover:bg-primary-500 hover:text-white"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.changePassword')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", _hoisted_4, [
      _createVNode(_component_RouterLink, {
        to: "/settings/connections",
        class: "block rounded-md font-medium py-[8.5px] px-[15px] text-primary-500 border border-primary-500 transition-all hover:bg-primary-500 hover:text-white"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.connections')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", _hoisted_5, [
      _createVNode(_component_RouterLink, {
        to: "/settings/leads-settings",
        class: "block rounded-md font-medium py-[8.5px] px-[15px] text-primary-500 border border-primary-500 transition-all hover:bg-primary-500 hover:text-white"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.leadsSettings')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", _hoisted_6, [
      _createVNode(_component_RouterLink, {
        to: "/settings/customers-settings",
        class: "block rounded-md font-medium py-[8.5px] px-[15px] text-primary-500 border border-primary-500 transition-all hover:bg-primary-500 hover:text-white"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.directT('settings.nav.customersSettings')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}